export default __webpack_public_path__ + "empty-pipeline-md.bf6f4296.svg";